import React from 'react';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';

const SectionCard = ({ index, imageSrc, headline, text, paragraphs = [] }) => {
  const isLeftSection = index === 1 || index === 3;

  return (
    <Paper
      elevation={3}
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        alignItems: 'center',
        justifyContent: 'space-around',
        padding: 6,
        textAlign: { xs: 'center', sm: 'left' },
        marginBottom: '40px',
        width: '100%',
        maxWidth: '1200px',
      }}
    >
      <Box
        sx={{
          flex: 1,
          textAlign: 'left',
          margin: { xs: '16px 0', sm: 0 },
          order: isLeftSection ? 2 : 'unset',
        }}
      >
        <Typography variant="h5" gutterBottom>
          {headline}
        </Typography>
        <Typography variant="body1">{text}</Typography>
        {paragraphs.map((p, i) => (
          <Typography key={i} variant="body1" sx={{ mt: 1 }}>{p}</Typography>
        ))}
      </Box>
      {imageSrc && (
        <img
          src={imageSrc}
          alt={headline}
          style={{
            maxWidth: 400,
            maxHeight: 300,
            borderRadius: 4,
            padding: 20,
            order: isLeftSection ? 1 : 'unset',
          }}
        />
      )}
    </Paper>
  );
};

export default SectionCard;